<script lang="ts" setup>
provide(INJECTION_KEYS.AuthorizationTheme, ThemeEnum.dark);

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const productCartStore = useProductCartStore();
const subscribeProductsStore = useSubscribeProductsStore();

const onCompleted = () => {
  productCartStore.transferCartData();
  subscribeProductsStore.transfer();
  router.push(
    (typeof route.query.redirectUrl === 'string' && route.query.redirectUrl) ||
      '/profile',
  );
};

if (userStore.authorized) {
  if (import.meta.server) await navigateTo('/profile');
  else router.push('/profile');
}
</script>

<template>
  <AuthFullFlow @completed="onCompleted" with-router />
</template>
